import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=3dd6060d&scoped=true"
import script from "./MenuMobile.vue?vue&type=script&lang=ts"
export * from "./MenuMobile.vue?vue&type=script&lang=ts"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=3dd6060d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd6060d",
  null
  
)

export default component.exports